"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolbar_html_1 = __importDefault(require("./toolbar.html"));
require("./toolbar.less");
(function (module) {
    module.component('prToolbar', {
        templateUrl: toolbar_html_1.default,
        require: {
            '$bdyCtrl': '^^prBody'
        }
    });
})(angular.module('qualtrics.pr'));
